import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	searchPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	searchPlaceholder: {
		id: 'jql-builder-basic-picker.async-select.select.search-placeholder',
		defaultMessage: 'Search',
		description: 'Placeholder text in search input indicating that the user can search',
	},
});

export default messages;
